import { render } from "./banerStrony.vue?vue&type=template&id=47efd836&scoped=true"
import script from "./banerStrony.vue?vue&type=script&lang=js"
export * from "./banerStrony.vue?vue&type=script&lang=js"

import "./banerStrony.vue?vue&type=style&index=0&id=47efd836&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47efd836"]])

export default __exports__